import _ from 'lodash';

import React from 'react';
import createClass from 'create-react-class';
import { withTranslation } from 'react-i18next';

import { NavLink } from 'react-router-dom';

import ProfileComponent from './ProfileComponent.react';
import TitleManager from '../../../../utils/TitleManager';

import BasketComponent from './basket/BasketComponent.react';

import DisplayCurrencyComponent from './display-currency/DisplayCurrencyComponent.react';

import CombtasBar from './CombtasBar';
import LanguageSwitcher from './LanguageSwitcher';

import Config from 'arbitrip-common/client/utils/Config';
import DocumentTitle from '../../../general/DocumentTitle.react';

import Analytics from 'arbitrip-common/client/analytics';
import { UTM_SOURCE_PARAMETER } from 'arbitrip-common/client/constants/ProfileConstants';
import { LOGOS } from 'arbitrip-common/client/constants/BrandConstants';
import { getLetstayPartnerLogoUrl } from 'arbitrip-common/client/utils/letstayPartnerLogo';

function invertColors() {
	document.documentElement.style.webkitFilter = document.documentElement.style.webkitFilter ? '' : 'invert(100%)';
}

function reloadCss() {
	let h, a, f;
	a = document.getElementsByTagName('link');
	for (h = 0; h < a.length; h++) {
		f = a[h];
		if (f.rel.toLowerCase().match(/stylesheet/) && f.href) {
			const g = f.href.replace(/(&|%5C?)forceReload=\d+/, '');
			f.href = g + (g.match(/\?/) ? '&' : '?') + 'forceReload=' + new Date().valueOf();
		}
	}
}

const TopBar = createClass({
	displayName: 'TopBar',

	render: function () {
		const { t } = this.props;
		const profile = this.props.user;
		const partner_login_company_name = _.get(this.props, 'user.partner_login_company_name', false);
		const COMPANY_NAME = partner_login_company_name || this.props.company.name;
		let title = TitleManager.defaults();
		if (profile.travel_manager) {
			title = TitleManager.buildTitleEndsWith('for ' + COMPANY_NAME, false);
		}

		let LOGO_CLASSES = 'image';
		if (Config.dev_mode === true) {
			LOGO_CLASSES += ' dead-logo';
		}

		if (Config.is_letstay) {
			LOGO_CLASSES += ' letstay';
		}

		let SHOW_HOTEL_BOOKING_BUTTONS = true;
		if (this.props.company.settings.management_enabled) {
			if (!this.props.company.settings.employees_hotel_booking_enabled && !profile.travel_manager) {
				SHOW_HOTEL_BOOKING_BUTTONS = false;
			}
		}

		const partners_ui = _.get(profile, 'company.partners_ui', {});
		const { hide_basket, hide_brand, hide_user_menu } = partners_ui;

		let img_title = 'Arbitrip.com';
		let BASE_LOGO_IMG = <img src={LOGOS.ARBITRIP} alt={img_title} className={LOGO_CLASSES} />;

		if (this.props.company.custom_header_logo) {
			img_title = this.props.company.custom_header_alt;
			BASE_LOGO_IMG = (
				<img src={this.props.company.custom_header_logo} alt={img_title} className={LOGO_CLASSES} />
			);
		}

		// Use the partner logo from utm_source if available
		const URLParams = new URLSearchParams(document.location.search);
		const utmSource = URLParams.get(UTM_SOURCE_PARAMETER);
		const partnerLogo = getLetstayPartnerLogoUrl(utmSource);

		return (
			<DocumentTitle title={title}>
				<div className="top-bar">
					<div className="company-bar">
						<div className="inner-company-bar">
							<div className="company-bar-div logo-div">
								<NavLink
									to="/"
									title={img_title}
									id="logo"
									className="link"
									onClick={() => Analytics.actions.interactions.logoClicked(profile)}
								>
									<div className="logo">
										{BASE_LOGO_IMG}
										{partnerLogo ? (
											<>
												<span className="logo-with-text">{t('With')}</span>
												<img src={partnerLogo} alt={utmSource} className={LOGO_CLASSES} />
											</>
										) : null}
									</div>
								</NavLink>
							</div>
							<div className="navigation-container">
								{this.props.company.settings.management_enabled ? (
									<div className="company-bar-div navigation-div">
										<NavLink to="/trips" className="hvr-underline-from-center">
											{t('Navigation.Trips')}
										</NavLink>
									</div>
								) : null}

								{SHOW_HOTEL_BOOKING_BUTTONS
									? [
											<div className="company-bar-div navigation-div" key="hotels">
												<NavLink
													to="/search"
													className="hvr-underline-from-center"
													onClick={() =>
														Analytics.actions.interactions.searchClicked(profile)
													}
												>
													{this.props.company.settings.management_enabled
														? t('Navigation.Hotels')
														: t('Navigation.Search')}
												</NavLink>
											</div>,
											<div className="company-bar-div navigation-div" key="bookings">
												<NavLink
													to="/bookings"
													className="hvr-underline-from-center"
													onClick={() =>
														Analytics.actions.interactions.bookingsClicked(profile)
													}
													data-testid="booking-nav-link"
												>
													{t('Navigation.Bookings')}
												</NavLink>
											</div>,
											profile.approval_flow_enabled ? (
												<div className="company-bar-div navigation-div" key="requests">
													<NavLink to="/requests" className="hvr-underline-from-center">
														{t('Navigation.Requests')}
													</NavLink>
												</div>
											) : null,
										]
									: null}

								{profile.reports_dashboard ? (
									<div className="company-bar-div navigation-div">
										<NavLink to="/dashboard" className="hvr-underline-from-center">
											{t('Navigation.Dashboard')}
										</NavLink>
									</div>
								) : null}

								{!hide_basket && SHOW_HOTEL_BOOKING_BUTTONS && (
									<div className="company-bar-div basket-div" aria-label="Send hotels for review">
										<BasketComponent profile={profile} />
									</div>
								)}

								<div className="profile-container">
									<div className="company-bar-div display-currency-div">
										<DisplayCurrencyComponent
											profile={profile}
											reservationPage={this.props.reservationPage}
										/>
									</div>

									{profile.private_travel_only && (
										<LanguageSwitcher
											changeLanguage={this.props.changeLanguage}
											updateLanguageOnDB={this.props.updateLanguageOnDB}
										/>
									)}

									{!hide_brand && (
										<div
											className="company-bar-div company-name-div"
											title={COMPANY_NAME}
											onClick={Config.localhost ? invertColors : null}
											onDoubleClick={Config.localhost ? reloadCss : null}
										>
											{COMPANY_NAME}
										</div>
									)}
									{!hide_user_menu && (
										<div className="company-bar-div user-name-div">
											<ProfileComponent />
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
					<hr className="shadower" />
					{this.props.showCombtasBar && (
						<CombtasBar endCombtasSession={this.props.endCombtasSession} tasId={this.props.tasId} />
					)}
				</div>
			</DocumentTitle>
		);
	},
});

export default withTranslation()(TopBar);
